export const selectIsLoading = (state) => state.firstLoginModal.loader
export const selectMessage = (state) => state.firstLoginModal.message
export const selectError = (state) => state.firstLoginModal.error
export const selectIsSuccussful = (state) => state.firstLoginModal.success
export const selectDefaultCountry = (state) => state.firstLoginModal.country
